import { Page, DataTable } from "@shopify/polaris";
import usePaymentData from "../../../../hook/usePaymentData";
import { extractHour } from "../TotalSummary/TotalSummary";
import { StoreCreditSummaryContainer } from "./StoreCreditSummary.styles";

export function StoreCreditSummary() {
  const { totalStoreCredit } = usePaymentData();

  const rows = (totalStoreCredit || []).map((payment) => [
    extractHour(payment.createdAt),
    `R$${(payment.amountCents / 100).toFixed(2)}`,
    payment.wasConciliation ? "Sim" : "Não",
    payment.orderName || "-",
  ]);

  let totalAmountCents = 0;
  for (const payment of totalStoreCredit || []) {
    const amountCents = parseInt(payment.amountCents, 10) || 0;
    totalAmountCents += amountCents;
  }

  const totalStoreCreditFormatted = `R$${(totalAmountCents / 100).toFixed(2)}`;

  return (
    <StoreCreditSummaryContainer>
      <Page title="Troca">
        <DataTable
          showTotalsInFooter
          truncate
          fixedFirstColumns
          columnContentTypes={["text", "numeric", "numeric", "text"]}
          headings={["Hora", "Valor", "Avulso", "Pedido"]}
          rows={rows}
          totals={["", totalStoreCreditFormatted, "", ""]}
          totalsName={{
            singular: "Total",
          }}
        />
      </Page>
    </StoreCreditSummaryContainer>
  );
}
